<template>
    <div class="input__container">
        <span class="float-placeholder active" :class="{required: config.required}" v-if="hasContent&&hasLabel"><span v-if="config.required" class="required">*</span>{{config.label}}</span>
        <div class="slot-container" ref="input-container">
            <slot class="input"/>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'FloatingLabel',
    props: {
      config: {
        required: true,
        label: null,
        value: null,
      }
    },
    computed: {
      hasLabel(){ return  (this.config.label||'').length > 0 }
    },
    watch: {
      "config.value"(val){
        this.hasContent = val !== ''
      }
    },
    mounted() {
      this.formElement = this.$refs['input-container'].querySelector('input, select, textarea');

      if (this.formElement && !this.$options.propsData.config.value) {
        this.formElement.addEventListener('input', this.input);
        this.formElement.addEventListener('change', this.input);
        // this.formElement.addEventListener('blur', this.blur);
        // this.formElement.addEventListener('focus', this.focus);
        this.input(this.formElement)
      }
    },
    methods: {
      input(event) {
        let target = event
        if (target.target) target = target.target

        this.hasContent = target.value !== '';
        this.$emit('input');
      },
    },
    data(){
      return {
        hasContent: false,
      }
    }
  }
</script>
